<template>
  <v-app-bar app clipped-right color="blue-grey" dark dense>
    <router-link :to="{ name: 'home' }">
      <v-btn icon>
        <v-icon>home</v-icon>
      </v-btn>
    </router-link>
    <v-toolbar-title>{{ $t('amazeing') }}</v-toolbar-title>
    <v-spacer />
    <HelpDialog
      :buttontext='buttonText'
      :title="dialogTitle"
      :helptext="dialogHelptext"
      :displayHelp.sync="displayHelp"
    />
    <v-spacer />
    <v-toolbar-items>
      <ServerSelect />
    </v-toolbar-items>
  </v-app-bar>
</template>


<script>
import { mapGetters } from 'vuex';
import ServerSelect from './ServerSelect.vue';
import HelpDialog from './HelpDialog.vue';

export default {
  components: { HelpDialog, ServerSelect },
  data() {
    return {
      displayHelp: false,
    };
  },
  beforeRouteUpdate(from, to, next) {
    this.displayHelp = true;
    next();
  },
  computed: {
    ...mapGetters('tasks', ['getTaskById']),
    task() {
      console.log(this.$route);
      return this.getTaskById(parseInt(this.$route.params.id, 10));
    },
    buttonText() {
      if (this.task == null) {
        console.warn(`Task with id ${this.$route.params.id} is undefined!`);
        return 'Invalid Task';
      }
      console.log('TASK:',this.task)
      return `Task ${this.task.tasknumber}: ${this.task.name}`;
    },
    dialogTitle() {
      if (this.task == null) {
        return 'Invalid Task';
      }

      return this.task.name;
    },
    dialogHelptext() {
      if (this.task == null) {
        return 'Invalid Task, try reloading the page or reopening the task';
      }

      return this.task.helptext;
    },
  },
};
</script>